import request from "../utils/request";
export function getAiRoleReviewList(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/draft/list?${queryString}`,
        method: "get"
    });
}



export function getAiRoleReviewById(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/draft/getById?${queryString}`,
        method: "get"
    });
}


export function updateAiRoleReviewStatus(params) {
    return request({
        url: `/draft/updateStatus`,
        method: "post",
        data: params
    });
}
